import { cardItems } from '@/mocks/home';

const tagBg: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            热播剧集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            全网热播电视剧一网打尽，高清不缓冲畅快追
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer no-underline block hover:border-primary-200 transition-colors"
            >
              <div className="flex">
                <div className="w-[120px] sm:w-[140px] flex-shrink-0 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-between min-w-0">
                  <div>
                    <div className="flex items-center gap-2 mb-1.5">
                      <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading truncate">
                        {item.title}
                      </h3>
                      <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-semibold ${tagBg[item.tagColor] || tagBg.primary}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                      {item.description}
                    </p>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 text-xs text-foreground-400">
                      <span className="text-accent-500 font-bold">{item.rating}</span>
                      <span>|</span>
                      <span>{item.genre}</span>
                    </div>
                    <p className="text-xs text-primary-500 mt-1 font-medium">{item.update}</p>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}